module.exports = __webpack_public_path__ + "img/border_middle_brackets.143b9033.svg";